import Purchase from './purchase-modal';

export default Purchase;
